(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignServiceFeeDialogController', AssignServiceFeeDialogController);

    AssignServiceFeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AssignServiceFee'];

    function AssignServiceFeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AssignServiceFee) {
        var vm = this;

        vm.assignServiceFee = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assignServiceFee.id !== null) {
                AssignServiceFee.update(vm.assignServiceFee, onSaveSuccess, onSaveError);
            } else {
                AssignServiceFee.save(vm.assignServiceFee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:assignServiceFeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
